export const typography = {
    fontFamilyBase: "'Source Sans 3', Arial, sans-serif",
    fontFamilyClario: "'Clario', sans-serif",
    fontWeightRegular: '400',
    fontWeightMedium: '500',
    fontWeightSemiBold: '600',
    fontWeightBold: '700',
    fontSizeXs: '9px',
    fontSizeSm: '12px',
    fontSizeMd: '14px',
    fontSizeLg: '16px',
    fontSizeXl: '20px',
    fontSize2xl: '24px',
    fontSize3xl: '32px',
    fontSize4xl: '48px',
    lineHeightAuto: 'auto',
    lineHeight100: '100%',
    lineHeight160: '160%',
    lineHeight180: '180%',
    lineHeight200: '200%',
    lineHeightBodySm: '19px',
    typeDisplayFontSize: '48px',
    typeDisplayFontWeight: '600',
    typeDisplayLineHeight: 'auto',
    typeHeadingLgFontSize: '32px',
    typeHeadingLgFontWeight: '600',
    typeHeadingLgLineHeight: 'auto',
    typeHeadingMdFontSize: '24px',
    typeHeadingMdFontWeight: '600',
    typeHeadingMdLineHeight: 'auto',
    typeTitleLgFontSize: '20px',
    typeTitleLgFontWeight: '600',
    typeTitleLgLineHeight: '25px',
    typeTitleMdFontSize: '16px',
    typeTitleMdFontWeight: '600',
    typeTitleMdLineHeight: '180%',
    typeSubtitleMdFontSize: '14px',
    typeSubtitleMdFontWeight: '600',
    typeSubtitleMdLineHeight: '180%',
    typeParagraphLgFontSize: '16px',
    typeParagraphLgFontWeight: '600',
    typeParagraphLgLineHeight: '160%',
    typeParagraphLgRegularFontWeight: '400',
    typeParagraphLgRegularLineHeight: '160%',
    typeParagraphMdFontSize: '14px',
    typeParagraphMdFontWeight: '600',
    typeParagraphMdLineHeight: '180%',
    typeParagraphMdRegularFontWeight: '400',
    typeParagraphMdRegularLineHeight: '180%',
    typeParagraphSmFontSize: '12px',
    typeParagraphSmRegularFontWeight: '400',
    typeParagraphSmRegularLineHeight: '200%',
    typeLabelLgFontSize: '16px',
    typeLabelLgFontWeight: '600',
    typeLabelLgLineHeight: 'auto',
    typeLabelLgRegularFontWeight: '400',
    typeLabelLgRegularLineHeight: 'auto',
    typeLabelMdFontSize: '14px',
    typeLabelMdFontWeight: '600',
    typeLabelMdLineHeight: 'auto',
    typeLabelMdRegularFontWeight: '400',
    typeLabelMdRegularLineHeight: 'auto',
    typeLabelSmFontSize: '12px',
    typeLabelSmFontWeight: '600',
    typeLabelSmLineHeight: 'auto',
    typeLabelSmRegularFontWeight: '400',
    typeLabelSmRegularLineHeight: 'auto',
    typeLabelXsFontSize: '9px',
    typeLabelXsFontWeight: '600',
    typeLabelXsLineHeight: 'auto',
    typeLabelXsRegularFontWeight: '400',
    typeLabelXsRegularLineHeight: 'auto',
    typeCaptionSmFontSize: '12px',
    typeCaptionSmRegularFontWeight: '400',
    typeCaptionSmRegularLineHeight: '160%',
};
